import React from 'react';
import styled, {css} from 'styled-components';
import {FontStyles} from "../constants";

export const Span = styled.span`
  ${props => props.textStyle};
  ${props => !!props.center ? 'text-align: center' : ''};
  -webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;
`;